import { connect } from 'react-redux'
import { compose } from 'recompose'
import withType from 'components/common/hoc/withType'
import { getPageLocation } from 'selectors'
import OneColumnGenericPage from './OneColumnGenericPage'

const mapStateToProps = state => ({
  pathname: getPageLocation(state).pathname
})

export default compose(
  withType({
    type: 'OneColumnGenericPage',
    placeholders: ['footer', 'header', 'genericMainContent']
  }),
  connect(mapStateToProps)
)(OneColumnGenericPage)
